import { fromEvent as observableFromEvent } from "rxjs";
import { filter } from "rxjs/operators";
export class KeyboardService {
    constructor(canvasContainer) {
        this._keyDown$ = observableFromEvent(canvasContainer, "keydown").pipe(filter((evt) => ![HTMLInputElement, HTMLTextAreaElement, HTMLSelectElement].some((instance) => evt.target instanceof instance)));
        this._keyUp$ = observableFromEvent(canvasContainer, "keyup").pipe(filter((evt) => ![HTMLInputElement, HTMLTextAreaElement, HTMLSelectElement].some((instance) => evt.target instanceof instance)));
    }
    get keyDown$() {
        return this._keyDown$;
    }
    get keyUp$() {
        return this._keyUp$;
    }
}
//# sourceMappingURL=KeyboardService.js.map